import * as React from 'react';

import { IInstructorListProps } from './instructor-list.props.autogenerated';
import { IInstructorListData } from './instructor-list.data';

import { parse } from 'papaparse';
import { sendRequest, Image } from '@msdyn365-commerce/core';

import { convertProductAttributes } from '../../utilities/data-attribute-parser';
import { attrNames } from '../../utilities/global-constants';

export interface IInstructorListViewProps extends IInstructorListProps<IInstructorListData> {}

//----------------------------------------------------------
// CSV file format
//----------------------------------------------------------
export interface IInstructorBios {
    'Fragment Name': string,
    'Title': string,
    'Image': string,
    'Description': string
}

interface IInstructorListState {
    instructorBios: IInstructorBios[]
}

/**
 *
 * InstructorList component
 * @extends {React.PureComponent<IInstructorListProps<IInstructorListData>>}
 */
class InstructorList extends React.PureComponent<IInstructorListProps<IInstructorListData>> {
    public state: IInstructorListState = {
        instructorBios: []
    };

    //==========================================================================
    // PUBLIC METHODS
    //==========================================================================

    //------------------------------------------------------
    //------------------------------------------------------
    public async componentDidMount(): Promise<void> {

       // Fetch the CSV
       await sendRequest<string>(this.props.config.csvUrl, 'get').then(response => {

            // Parse the CSV
            const parsed = parse<IInstructorBios>(
                response.data,
                {
                    header: true,
                    delimiter: ',',
                    quoteChar: '"',
                    skipEmptyLines: true,
                }
            );

            // Handle errors
            if (parsed.errors?.length) {
                this.props.context.telemetry.warning('Errors occurred while parsing instructors CSV', parsed.errors);
            }

            const productAttributes = convertProductAttributes(this.props.data.productAttributes?.result || []);
            const instructorString = productAttributes[attrNames.instructors] as string || '';
            const instructors = instructorString.split('|');

            const productSpecificInstructors = parsed.data.filter(instructor => {
                return instructors.find(name => {
                    return name === instructor.Title;
                });
            });

            // set the result to state
            this.setState({instructorBios: productSpecificInstructors});

        });

    }

    //------------------------------------------------------
    //------------------------------------------------------
    public render(): JSX.Element | null {

        if (!this.state.instructorBios.length || !this.props.data.productAttributes.result?.length) {
            return null;
        }

        return (
            <div className='instructor-list'>
                {this.state.instructorBios.map((bio, index) => {
                    return (
                        <div key={index} className='instructor-list__bio'>
                            <div className='instructor-list__bio-name'>{bio.Title}</div>
                            <div className='instructor-list__bio-content'>
                                <div className='instructor-list__bio-image-container'>
                                    <Image
                                        className='instructor-list__bio-image'
                                        requestContext={this.props.context.actionContext.requestContext}
                                        gridSettings={this.props.context.request.gridSettings!}
                                        loadFailureBehavior='hide'
                                        src={`${this.props.context.request.apiSettings.baseImageUrl}Workers%2F${bio.Image}`}
                                    />
                                </div>
                                <div className='instructor-list__bio-description'>{bio.Description}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default InstructorList;
